import { render, staticRenderFns } from "./Vacation requests.vue?vue&type=template&id=ed5d05c2"
import script from "./Vacation requests.vue?vue&type=script&lang=js"
export * from "./Vacation requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports